import { createActionTypeModel } from "../../../../store/global/action-model";
export const SET_DISTRIBUTION_REPORT_NAB_ITEMS = 'SET_DISTRIBUTION_REPORT_NAB_ITEMS';
export const DistributionReportDetails = createActionTypeModel("DistributionReportDetails");